import type { FC } from 'react';
import Section from '@components/Section';

import './RiskLegend.scss';

const RiskLegend: FC<{ globeLegendTitle: string, gradient: boolean, className?: string }> = ({ globeLegendTitle, gradient, className }) => {
    return <Section
        title={globeLegendTitle}
        style={{
            width: 500,
            margin: '10px auto',
        }}
    >
        <div className="risk-legend">
            <div className={className + " " + (gradient ? `risk-legend__gradient` : `risk-legend__solid`)} />
            <div className={`risk-legend__text d-flex justify-content-between`}>
                {gradient ? <>
                    <div>Low</div>
                    <div>High</div>
                </> : <>
                    <div>Laggard</div>
                    <div>Mid performer</div>
                    <div>Leader</div>
                </>
                }
            </div>
        </div>
    </Section>
};

export default RiskLegend;
